/** vendor */
import React, { useEffect, useState } from 'react'

const CreateStoreDialog = ({ 
  showDialog = false, 
  store, 
  onSubmit = () => {}, 
  onCancel = () => {} 
}) => {
  const [isOpen, setIsOpen] = useState(true)

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  const validateText = (str) => {
    const validNamePattern = /^[a-zA-Z0-9\s]+$/;
    return str && validNamePattern.test(str)
  }

  /**
   * Hooks
   */
  useEffect(() => {
    if (store) {
        setName(store?.name)
        setDescription(store?.description)
    }
    
    setIsOpen(showDialog) 
  }, [showDialog])

  /**
   * Handlers
   */
  const handleNameChange = (e) => {
    setName(e.target.value)
  }

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value)
  }

  const handleCancel = () => {
    setIsOpen(false)
    onCancel()
  }

  const handleConfirm = () => {
    onSubmit({name, description})
    setIsOpen(false)
  }

  return (
    <div
      className={`fixed z-50 inset-0 overflow-y-auto ${
        isOpen ? 'flex' : 'hidden'
      } items-center justify-center`}
    >
      <div className="fixed inset-0 bg-an_green-dark opacity-60"></div>

      <div className="fixed bottom-0 left-0 w-full px-2">
        <div className="bg-an_white-dark rounded shadow-md w-full md:max-w-xl mx-auto z-50">
          <h2 className="w-full text-xl text-an_white text-center items-center p-4 bg-an_green-dark rounded-t">
            {store ? 'edit store' : 'create store'}
          </h2>

          <div className="flex min-w-full justify-center p-4"> 
              <div className="w-full">
                  <div className="mb-4 w-full">
                      <label htmlFor="name" className="block mb-2 text-base text-an_green-dark">name</label>
                      <div className="relative">
                          <input 
                              type="text" 
                              id="title"
                              value={name}
                              onChange={handleNameChange} 
                              className="border border-an_green-dark text-an_green-dark text-xs rounded block w-full pr-10 p-2.5" 
                              placeholder="pantry... fridge... freezer..."
                          />
                      </div>
                      <label className="block text-an_orange-dark mt-1">
                          { 
                              name.length > 0 && !validateText(name)
                                  ? 'may only contain letters, numbers and spaces' 
                                  : <>&nbsp;</>
                          }
                      </label>
                  </div>

                  <div className="mb-4 w-full">
                      <label htmlFor="description" className="block mb-2 text-base text-an_green-dark">description</label>
                      <textarea 
                          id="description" 
                          rows="4"
                          onChange={handleDescriptionChange}
                          value={description} 
                          className={
                            `${description.length > 0 && !validateText(description) ? 'border-an_orange-dark' : ''} border rounded w-full text-xs py-2 px-3 text-an_green-dark`
                          }    
                          placeholder="description (optional)"></textarea>
                      <label className="block text-an_orange-dark mt-1">
                          { 
                              description.length > 0 && !validateText(description)
                                  ? 'may only contain letters, numbers and spaces' 
                                  : <>&nbsp;</>
                          }
                      </label>
                  </div>
              </div>

          </div>
        </div>

        <div className="flex justify-center w-full py-3 md:max-w-xl mx-auto">
          <button
            className="px-5 py-2 rounded w-36 text-an_green-dark bg-an_white mr-1"
            onClick={handleCancel}
          >
            cancel
          </button>

          <button
            className={`
              ${!validateText(description) || !validateText(name) ? 'opacity-60' : ''} 
              px-5 ml-1 py-2 relative rounded w-36 border border-an_orange-darker3 
              text-an_white bg-an_orange text-border-orange
            `}
            onClick={handleConfirm}
          >
            confirm
          </button>
        </div>
      </div>
    </div>
  )
}

export default CreateStoreDialog
